module.exports = __webpack_public_path__ + "static/media/S (56).7abbf3dc.jpg";